let currentlyPlaying = null;

function getOrCreateVideo(card) {
  let video = card.querySelector('video');
  const videoUrl = card.getAttribute('data-video');

  if (!video && videoUrl) {
    video = document.createElement('video');
    video.src = videoUrl;
    video.muted = false;        // required for autoplay
    video.playsInline = true;  // required for iOS
    video.loop = false;
    video.controls = false;

    video.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
      z-index: 1;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    `;

    card.appendChild(video);
  }

  return video;
}

function playVideo(card) {
  const video = getOrCreateVideo(card);
  const cardImage = card.querySelector('.card-image');
  const playIcon = card.querySelector('.play-icon');

  if (!video) return;

  if (cardImage) cardImage.style.opacity = '0';
  if (playIcon) playIcon.style.opacity = '0';

  video.style.display = 'block';
  video.style.opacity = '1';
  video.play();

  currentlyPlaying = card;
}

function pauseVideo(card) {
  const video = card.querySelector('video');
  const cardImage = card.querySelector('.card-image');
  const playIcon = card.querySelector('.play-icon');

  if (!video) return;

  video.pause();
  video.style.opacity = '0';

  if (cardImage) cardImage.style.opacity = '1';
  if (playIcon) playIcon.style.opacity = '1';

  currentlyPlaying = null;
}

function stopOtherAndPlay(card) {
  if (currentlyPlaying && currentlyPlaying !== card) {
    pauseVideo(currentlyPlaying);
  }
  playVideo(card);
}

document.querySelectorAll('.card').forEach(card => {
  // Desktop hover behavior
  card.addEventListener('pointerenter', (e) => {
    if (e.pointerType !== 'mouse') return;
    stopOtherAndPlay(card);
  });

  card.addEventListener('pointerleave', (e) => {
    if (e.pointerType !== 'mouse') return;
    pauseVideo(card);
  });

  // Mobile / touch toggle
  card.addEventListener('pointerup', (e) => {
    if (e.pointerType === 'mouse') return;
    e.preventDefault();

    const video = card.querySelector('video');
    if (!video) {
      stopOtherAndPlay(card);
      return;
    }

    if (video.paused) stopOtherAndPlay(card);
    else pauseVideo(card);
  });

  // Keyboard users
  card.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const video = card.querySelector('video');
      if (video && !video.paused) pauseVideo(card);
      else stopOtherAndPlay(card);
    }
  });

  card.style.touchAction = 'manipulation';
});
